var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.privileged
    ? _c("div", { staticClass: "campaign-marketing" }, [
        _c(
          "div",
          {
            staticClass: "vs-container--settings-small",
            class: {
              "campaign-details--hide-button": _vm.activeTab === "urlbuilder"
            }
          },
          [
            _vm.campaignEnded
              ? _c("vs-alert", {
                  staticClass: "vs-alert--campaign",
                  attrs: {
                    "no-gutter": "no-gutter",
                    message: "!--- Editing is Disabled ---!"
                  }
                })
              : _vm._e(),
            _c(
              "vs-container",
              {
                attrs: {
                  "hide-search": "hide-search",
                  "hide-date": "hide-date",
                  title: "Marketing",
                  "button-icon": "content-save",
                  "button-text": "save",
                  "button-not-visible":
                    _vm.campaignEnded || _vm.activeTab === "urlbuilder",
                  "button-disabled":
                    _vm.campaignEnded ||
                    _vm.activeTab === "urlbuilder" ||
                    _vm.processing,
                  tabs: _vm.tabs,
                  "active-tab": _vm.activeTab,
                  processing: _vm.processing
                },
                on: {
                  "container-button-click": _vm.save,
                  "change-tab": _vm.handleChangeTab
                }
              },
              [_c("router-view")],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }